import type { PedidoCliente } from '@/types';

const ESTATUS_PAGO: Record<string, string> = {
  pendiente: 'Pendiente de pago',
  pagado: 'Pagado',
  cancelado: 'Cancelado',
  completado: 'Completado',
};

const ESTATUS_ENVIO: Record<string, string> = {
  pendiente: 'Por preparar',
  preparando: 'En preparación',
  enviado: 'Enviado',
  entregado: 'Entregado',
};

export function etiquetaEstatusPago(estatus: string): string {
  return ESTATUS_PAGO[estatus] ?? estatus;
}

export function etiquetaEstatusEnvio(estatus: string): string {
  return ESTATUS_ENVIO[estatus] ?? estatus;
}

export function claseBadgePago(estatus: string): string {
  switch (estatus) {
    case 'pagado':
    case 'completado':
      return 'bg-emerald-100 text-emerald-800';
    case 'cancelado':
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-amber-100 text-amber-800';
  }
}

export function claseBadgeEnvio(estatus: string): string {
  switch (estatus) {
    case 'entregado':
      return 'bg-emerald-100 text-emerald-800';
    case 'enviado':
      return 'bg-sky-100 text-sky-800';
    case 'preparando':
      return 'bg-violet-100 text-violet-800';
    default:
      return 'bg-surface-100 text-surface-700';
  }
}

export function formatearFechaPedido(fecha: string): string {
  try {
    return new Intl.DateTimeFormat('es-MX', {
      dateStyle: 'medium',
      timeStyle: 'short',
    }).format(new Date(fecha.replace(' ', 'T')));
  } catch {
    return fecha;
  }
}

export function etiquetaMetodoPago(pedido: PedidoCliente): string {
  if (pedido.metodo_pago === 'stripe') return 'Tarjeta (Stripe)';
  if (pedido.metodo_pago === 'pendiente') return 'Transferencia / pendiente';
  return pedido.metodo_pago ?? '—';
}
